import _regeneratorRuntime from "/data/jenkins/workspace/hbl-web-mobile-prod/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/data/jenkins/workspace/hbl-web-mobile-prod/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { App as CapacitorApp } from '@capacitor/app';
import { setToken } from '@/utils';
import { IN_APP } from '@/config/env';
import { Toast } from 'vant';
export default {
  name: 'App',
  components: {
    IonApp: IonApp,
    IonRouterOutlet: IonRouterOutlet
  },
  data: function data() {
    return {
      userInfoLoaded: false
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.dispatch('getUserInfo').then(function () {
                _this.userInfoLoaded = true;
              });

              _this.$store.dispatch('getAppConfig').then(function (res) {
                if (res.grayMode) {
                  document.querySelector('body').style.filter = 'grayscale(100%)';
                }
              });

              _this.$store.dispatch('getFavoriteGoods');

              _this.$store.dispatch('getCategory');

              _this.$store.dispatch('getMyTodoCount');

              _this.$store.dispatch('LoadMerchantShopingCardData');

              _this.listenerBackButton();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 退出应用程序
    listenerBackButton: function listenerBackButton() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var lastBackTime;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                lastBackTime = 0;
                CapacitorApp.addListener('backButton', function (_ref) {
                  var canGoBack = _ref.canGoBack;

                  if (!canGoBack) {
                    if (new Date().getTime() - lastBackTime < 2000) {
                      CapacitorApp.exitApp();
                    } else {
                      lastBackTime = new Date().getTime();
                      Toast({
                        position: 'bottom',
                        message: '再按一次退出~'
                      });
                    }
                  } else {
                    lastBackTime = 0;
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};